import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components

import SectionDivider from '../molecules/SectionDivider';
import TextParagraph from '../atoms/TextParagraph';
import CreditCard from './CreditCard';
import AddCreditCard from './AddCreditCard';

//Returning the component
class PaymentMethod extends Component {
	render() {
		return (
			<div className="paymentMethod margin-b-md">
				<SectionDivider heading="Payment method" />
				<TextParagraph classType="margin-b-sm" text="Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritat." />
				<div className="row">
					<div className="col-sm-12 col-md-6 col-lg-4">
						<CreditCard company="Nordea Bank Ab" number="**** **** **** 2562" date="2018/07/10" />
					</div>
					<div className="col-sm-12 col-md-6 col-lg-4">
						<AddCreditCard />
					</div>
				</div>
				</div>
				)
	}
}

//Making sure that it has a text property when it's declared
PaymentMethod.propTypes = {
					test: PropTypes.string, //Write some props here if needed, just using this to not have errors
}

export default PaymentMethod;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/PaymentMethod.jsx